import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { reset, initialize } from 'redux-form';
import { connect } from 'react-redux';
import { Modal } from '@unite-us/app-components';
import EditButton from 'common/display/Profile/components/EditButton';
import './EditModal.scss';

export class ModalEditForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false,
    };

    this.onCancel = this.onCancel.bind(this);
    this.openDialog = this.openDialog.bind(this);
  }

  onCancel() {
    this.setState({ modalIsOpen: false });
    this.documentDialog.closeModal('cancel');
  }

  openDialog() {
    this.setState({ modalIsOpen: true });
    this.documentDialog.openModal();
  }

  render() {
    const {
      buttonId,
      children,
      disabled,
      header,
      id,
      labelText,
      removeCloseIcon,
      showEdit,
      size,
    } = this.props;

    const childrenWithFuncs = React.Children.map(children, (child) => (
      React.cloneElement(child, {
        closeModal: this.onCancel,
        modalIsOpen: this.state.modalIsOpen,
      })
    ));

    return (
      <div className="edit-modal">
        {
          showEdit && (
            <EditButton
              disabled={disabled}
              edit={this.openDialog}
              id={buttonId}
              labelText={labelText}
              aria-label={buttonId.replace(/-/g, ' ').replace('btn', '').trim()}
            />
          )
        }
        <Modal
          id={id}
          title={header}
          removeCloseIcon={removeCloseIcon}
          size={size}
          modal
          showBorderRadius
          ref={(el) => { this.documentDialog = el; }}
          footerStyles="border-t border-solid border-dark-border-grey p-4 box-border text-right flex-3 mt-10"
        >
          {childrenWithFuncs}
        </Modal>
      </div>
    );
  }
}

ModalEditForm.propTypes = {
  buttonId: PropTypes.string.isRequired,
  children: PropTypes.node,
  disabled: PropTypes.bool.isRequired,
  header: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  removeCloseIcon: PropTypes.bool,
  showEdit: PropTypes.bool.isRequired,
  size: PropTypes.string,
  labelText: PropTypes.string,
};

ModalEditForm.defaultProps = {
  clearCurrentSelectedId: noop,
  dialogContentStyles: {},
  disabled: false,
  fields: [],
  initialValues: {},
  labelText: 'Edit',
  modalOpenCallback: noop,
  showEdit: true,
  removeCloseIcon: false,
};

export default connect(undefined, { reset, initialize })(ModalEditForm);
